import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'cinema', ...(require('/app/build/src/models/cinema.ts').default) });
app.model({ namespace: 'home', ...(require('/app/build/src/models/home.ts').default) });
app.model({ namespace: 'initData', ...(require('/app/build/src/models/initData.ts').default) });
app.model({ namespace: 'movie', ...(require('/app/build/src/models/movie.ts').default) });
app.model({ namespace: 'order', ...(require('/app/build/src/models/order.ts').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
